import { createContext } from 'react';

/**
 * The width components should lay out against, which is NOT the window width once the app is
 * boxed into a column on a wide screen. Null means "no column here", so consumers fall back to
 * the window width — that is the native case, where the app fills the screen.
 */
export const ContentWidthContext = createContext<number | null>(null);
